import React, { Component } from 'react';
import __ from '../../../../components/interop/i18n';

import _ from 'lodash';

import {
  FUSE_COLORS,
  FUSE_NAMES_EN,
  FUSE_NAMES_ES,
  FUSE_NAMES_PT,
  FUSE_SIZES,
  getSemanticIcon
} from './FuseboxData.mjs';

let FUSE_NAMES_LOCALIZED;
// window.config.locale will be replaced in bundle step by a constant, and unused locales will be tree-shaked by ESBUILD
window.config = window.config || {};
if(window.config.locale === 'en') {
  FUSE_NAMES_LOCALIZED = FUSE_NAMES_EN;
} else if(window.config?.locale === 'pt') {
  FUSE_NAMES_LOCALIZED = FUSE_NAMES_PT;
} else {
  FUSE_NAMES_LOCALIZED = FUSE_NAMES_ES;
}

function hexToRgb(hex) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function(m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}


function contrastRequiresBlack(bgColor) {
  const {r,g,b} = _.isString(bgColor) ? hexToRgb(bgColor) : bgColor
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return (yiq >= 128);
}

function fuseImageFormat(fuse) {
  let { type, format } = fuse.kind || {};
  if(type) {
    let imageSpecification = FUSE_SIZES[type] && (FUSE_SIZES[type][format] || FUSE_SIZES[type]['all']);

    if (FUSE_SIZES[type] && fuse.vertical) {
      imageSpecification = FUSE_SIZES[type][format + "-vertical"] || FUSE_SIZES[type]['all-vertical'] || imageSpecification;
    }

    return imageSpecification;
  }
}

function mergeLayoutBoxes({left, top, width, height, ... other}, l2) {
  const newLeft = Math.min(left, l2.left);
  const newTop = Math.min(top, l2.top);
  return {
    left: newLeft,
    top: newTop,
    width: Math.max(left+width, l2.left+l2.width) - newLeft,
    height: Math.max(top+height, l2.top+l2.height) - newTop,
    ... other
  }
}

function areTouching({left, top, width, height, ... other}, f2) {
  return !((top + height) < f2.top
    || (left + width) < f2.left
    || top > (f2.top + f2.height)
    || left > (f2.left + f2.width))
}

function rotate(cx, cy, x, y, angle) {
  // Rotate in the same coordinate system as CSS (Y axis increases downwards)
  const radians = -(Math.PI / 180) * angle,
    cos = Math.cos(radians),
    sin = Math.sin(radians),
    nx = (cos * (x - cx)) - (sin * (-y + cy)) + cx,
    ny = (cos * (-y + cy)) + (sin * (x - cx)) - cy;

  return [nx, -ny];
}

function overlap(cx, cy, rad, width, height, left, top) {
  // Circle bounds
  const circleLeft = cx - rad;
  const circleRight = cx + rad;
  const circleTop = cy - rad;
  const circleBottom = cy + rad;

  // Rectangle bounds
  const rectRight = left + width;
  const rectBottom = top + height;

  // Calculate the intersection rectangle
  const intersectLeft = Math.max(circleLeft, left);
  const intersectRight = Math.min(circleRight, rectRight);
  const intersectTop = Math.max(circleTop, top);
  const intersectBottom = Math.min(circleBottom, rectBottom);

  // Check if there is an intersection
  if (intersectLeft < intersectRight && intersectTop < intersectBottom) {
    const intersectArea = (intersectRight - intersectLeft) * (intersectBottom - intersectTop);
    const fuseArea = width*height;
    return (intersectArea / fuseArea); // Percentage of the circle overlapping
  }
  return 0; // No overlap
}


function distanceToBoxRotated(x, y, left, top, width, height, rotation) {
  // Convert rotation angle from degrees to radians
  const angle = (rotation * Math.PI) / 180;

  // Calculate the center of the box
  const centerX = left + width / 2;
  const centerY = top + height / 2;

  // Translate the point (x, y) to the box's coordinate system (centered at the box's center)
  const translatedX = x - centerX;
  const translatedY = y - centerY;

  // Apply reverse rotation to the point
  const rotatedX = translatedX * Math.cos(-angle) - translatedY * Math.sin(-angle);
  const rotatedY = translatedX * Math.sin(-angle) + translatedY * Math.cos(-angle);

  // Translate the point back to the original coordinate system
  const unrotatedX = rotatedX + centerX;
  const unrotatedY = rotatedY + centerY;

  // Box boundaries in the unrotated coordinate system
  const right = left + width;
  const bottom = top + height;

  // Check if the point is inside the box
  if (unrotatedX >= left && unrotatedX <= right && unrotatedY >= top && unrotatedY <= bottom) {
    // Compute the minimum distance to the perimeter from inside the box
    const distLeft = unrotatedX - left;
    const distRight = right - unrotatedX;
    const distTop = unrotatedY - top;
    const distBottom = bottom - unrotatedY;
    return -Math.min(distLeft, distRight, distTop, distBottom);
  } else {
    // Compute the horizontal and vertical distances to the box
    const dx = unrotatedX < left ? left - unrotatedX : unrotatedX > right ? unrotatedX - right : 0;
    const dy = unrotatedY < top ? top - unrotatedY : unrotatedY > bottom ? unrotatedY - bottom : 0;

    // Return the Euclidean distance to the box
    return Math.sqrt(dx * dx + dy * dy);
  }
}

class FuseboxDiagram extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // fusebox: this.preprocessDiagram(this.props.fusebox),
      selected: this.props.selected || [],
      maxHeight: 100,
      maxWidth: 100,
      extraRotation: 0,
      fullScreenAutoRotation: 0,
      wideLayouInColumns: false,
      currentSearch: props.initialSearch || '',
      highlightedIds: props.highlightedIds
    }

    this.containerRef = React.createRef();
    this.diagramCellRef = React.createRef();
    this.viewportRef = React.createRef();
    this._updateDimensionsImmediate = this.updateDimensions.bind(this);
    this.updateDimensions = () => {
      if(this._resizeRAF) cancelAnimationFrame(this._resizeRAF);
      this._resizeRAF = requestAnimationFrame(() => this._updateDimensionsImmediate());
    };
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);

    this._touchActive = false;
    this._touchStartPos = null;
    this._touchCurrentFuse = null;
    this._touchMoved = false;
    this._preventNextClick = false;

    let fuseboxId = Math.random();
  }

  // Used from the .pug fusebox page through React's component ref
  selectFuseByIndex(fuseIndex) {
    let matchingFuse = this.props.fusebox.fuses[fuseIndex];
    if(matchingFuse) {
      this.selectFuse(matchingFuse)
    }
  }

  selectFusesByIndexes(fuseIndexes) {
    let matchingFuses = _.compact(fuseIndexes.map(fuseIndex => this.props.fusebox.fuses[fuseIndex]));
    this.setState({ selected: matchingFuses, hoverSelection: true });
  }

  highlightFuses(fuseIndexes) {
    let validIds = _.uniq(_.compact(fuseIndexes.map(fuseIndex => this.props.fusebox.fuses[fuseIndex]?.id)));
    console.log("Highlighting fuses", validIds);
    this.setState({ highlightedIds: validIds });
  }

  // Used from the .pug fusebox page through React's component ref
  hoverFuseByIndex(fuseIndex) {
    let matchingFuse = this.props.fusebox.fuses[fuseIndex];
    if(matchingFuse) {
      this.hoverFuse(matchingFuse)
    }
  }

  selectFuse(fuse, e) {
    if (this.props.fuseTouchContinuousHover && this._preventNextClick) {
      this._preventNextClick = false;
      if (e) e.stopPropagation();
      return;
    }
    if(fuse) {
      // Function as a toggle
      if(this.state.selected.length === 1 && this.state.selected[0].id === fuse.id && !this.state.hoverSelection) {
        this.setState({ selected: [], hoverSelection: false });
      } else {
        this.setState({ selected: [fuse], hoverSelection: false });
      }
      if(e) {
        e.stopPropagation();
      }
    } else {
      this.setState({ selected: [], hoverSelection: false });
    }

    if(this.props.onSelectFuse) {
      this.props.onSelectFuse(fuse, e);
    }
  }

  hoverFuse(fuse, e) {
    if (this.props.fuseTouchContinuousHover && !fuse && this._touchActive) return;

    if (fuse && (!this.state.selected.length || this.state.hoverSelection)) {
      this.setState({ selected: [fuse], hoverSelection: true });
    } else if (this.state.hoverSelection) {
      this.setState({ selected: [], hoverSelection: false });
    }

    if (this.props.onHoverFuse) {
      this.props.onHoverFuse(fuse, e);
    }
  }

  handleFuseTouchStart(fuse, e) {
    if (!this.props.fuseTouchContinuousHover) return;
    if (e.touches.length > 1) return;
    this._touchActive = true;
    this._touchStartPos = { x: e.touches[0].clientX, y: e.touches[0].clientY };
    this._touchCurrentFuse = fuse;
    this._touchMoved = false;
    this.setState({ selected: [fuse], hoverSelection: true });
  }

  cancelTouchHover() {
    this._touchActive = false;
    this._touchCurrentFuse = null;
    this._touchMoved = false;
  }

  handleTouchMove(e) {
    if (!this._touchActive) return;

    if (e.touches.length > 1) {
      this.cancelTouchHover();
      return;
    }

    const touch = e.touches[0];
    const dx = touch.clientX - this._touchStartPos.x;
    const dy = touch.clientY - this._touchStartPos.y;

    // if (Math.abs(dx) > 10 || Math.abs(dy) > 10) {
      this._touchMoved = true;
    // }

    if (this._touchMoved) {
      e.preventDefault();
    }

    const fuse = this.getFuseFromPoint(touch.clientX, touch.clientY);

    if (fuse?.id !== this._touchCurrentFuse?.id) {
      this._touchCurrentFuse = fuse;
      this.hoverFuse(fuse);
    }
  }

  handleTouchEnd(e) {
    if (!this._touchActive) return;

    const wasMoved = this._touchMoved;

    if (wasMoved) {
      if (this._touchCurrentFuse) {
        this.selectFuse(this._touchCurrentFuse);
      } else {
        this.hoverFuse(null);
      }
      this._preventNextClick = true;
      setTimeout(() => { this._preventNextClick = false; }, 300);
    }

    this._touchActive = false;
    this._touchCurrentFuse = null;
    this._touchMoved = false;
  }

  getFuseFromPoint(x, y) {
    if (!this.preprocessed) return null;

    const el = document.elementFromPoint(x, y);
    if (!el) return null;

    const fuseEl = el.closest('[data-fuse-idx]');
    if (fuseEl) {
      const idx = parseInt(fuseEl.getAttribute('data-fuse-idx'));
      return this.preprocessed.fuses[idx] || null;
    }

    const iconEl = el.closest('[data-icon-idx]');
    if (iconEl) {
      const idx = parseInt(iconEl.getAttribute('data-icon-idx'));
      return this.preprocessed.icons[idx]?.fuse || null;
    }

    return null;
  }

  renderFuse(fuse, viewBox, i) {
    let {kind, layout, id, vertical, onlyBlockSelection, description, npc, option, totalOptions} = fuse;

    if(!layout?.width) {
      if(this.props.development && !this.props.marks) {
        return <span className={'badge badge-danger m-1'} key={id + i}>{id}</span>
      } else {
        return null
      }
    }

    let { amp, variation, type, format, notUsed } = kind;

    // Cheap way to reuse the same image in different fuse formats
    format = (format || "")
      .replace(/cartridge-flf$/i, 'cartridge-flm')

    let colorClass = '';

    if(amp || (type === 'fuse' && notUsed === false)) {
      colorClass += ` fuse-amp-${(amp || '').toString().replace('.', '_')}`;
    }

    if(variation && !notUsed) {
      colorClass += ` fuse-var-${variation}`;
    }

    if(notUsed === true || (type === 'fuse' && notUsed !== false && !amp)) {
      colorClass += ` ${type}-empty`;
      colorClass += ` fuse-amp-empty`;
    }

    if (vertical) {
      colorClass += " vertical"
    }

    if(totalOptions) {
      colorClass += ` option-${option}-of-${totalOptions}`;
    }

    const formatClass = format  ? `${type}-${format}` : ""

    let fuseStyle = this.getBoxCss(layout, viewBox);

    if (type === 'svg') {
      fuseStyle.zIndex = '0';
    } else {
      // Order components from right to left, and from their bottom
      fuseStyle.zIndex = `${Math.max(1, Math.round(10*(layout.top+layout.height) - layout.left))}`;
    }

    if(layout.flipHorizontal) { // Has to be BEFORE rotation
      fuseStyle.transform = ((fuseStyle.transform || '') + ` scaleX(-1)`).trim();
    }
    if(layout.rotation) {
      fuseStyle.transform = ((fuseStyle.transform || '') + ` rotate(${layout.rotation}deg)`).trim();
    }
    if(layout.translateX) {
      fuseStyle.transform = ((fuseStyle.transform || '') + ` translateX(${layout.translateX})`).trim();
    }
    if(layout.translateY) {
      fuseStyle.transform = ((fuseStyle.transform || '') + ` translateY(${layout.translateY})`).trim();
    }


    let fuseClass = `fuse fuse-${type} ${colorClass} ${formatClass}`

    if(onlyBlockSelection) {
      fuseClass = `fuse fuse-transparent`
    }

    if(npc) {
      fuseClass += ' fuse-decoration';
    }

    if(!description && type !== 'fuse' && !npc && !this.props.development) {
      fuseClass += ' fuse-non-interactive';
    }

    const idSafeString = str => str.replace(" ", "");
    let fuseId = "fuse" + idSafeString(id);

    let inner = null;

    if (this.state.selected?.length || this.state.highlightedIds?.length) {
      if (_.includes(_.map(this.state.selected, 'id'), id) || _.includes(this.state.highlightedIds, id)) {
        if(!this.state.hoverSelection) {
          fuseClass += ' highlighted'
        } else {
          fuseClass += ' hovered'
        }
        fuseStyle.zIndex = '1001'
      }
    }

    if (type === "fuse" && !onlyBlockSelection) {
      inner = <div className={'amp'}>{amp}<span>A</span></div>;
    }

    if (type === "relay") {
      let text = (layout.hideText || (!description && id.toString().length <= 4)) ? '' : id;
      inner = <div className={'relay'}><span className={'small'}>{text}</span></div>;
    }

    if (type === "svg" && fuse.svgPaths?.length) {
      const vbH = fuse.svgViewBoxH || 100;
      // Override CSS variable --diagramBackground with fuse.color if provided
      const svgStyle = {
        position: 'absolute',
        top: '-10%',
        left: '-10%',
        width: '120%',
        height: '120%',
        ...(fuse.color ? { '--diagramBackground': fuse.color } : {}),
        '--svgScale': this.preprocessed.scale/fuse.layout.width
      };


      inner = <svg viewBox={`-10 -${vbH * 0.1} 120 ${vbH * 1.2}`} preserveAspectRatio="none"
                   style={svgStyle}>
        <path d={fuse.svgPaths.join(' ')} fill="var(--diagramBackground, #333)" fillRule="evenodd" stroke="none"/>
      </svg>;
    }

    const fuseMark = this.props.marks?.[id.toString()];
    if(fuseMark) {
      fuseClass += ' marked';
    }

    // showFuseIds (print view): overlay each fuse's id/number on the diagram, so the
    // paper version can be cross-referenced with the table without interactivity.
    let idLabel = null;
    if (this.props.showFuseIds && !npc && !onlyBlockSelection && type !== 'svg') {
      // Same condition as the fuse-non-interactive class: components with no description
      // that aren't fuses (connectors, misc hardware) have no table row to reference
      const nonInteractive = !description && type !== 'fuse';
      // Relays may already render their id as text (see the type === "relay" branch above)
      const relayShowsOwnId = type === 'relay' && !layout.hideText && (description || id.toString().length > 4);
      if (!nonInteractive && !relayShowsOwnId) {
        // Undo the fuse's transform (flip applied before rotation, so invert in reverse
        // order) to keep the label upright in screen orientation
        let labelStyle = null;
        if (layout.rotation || layout.flipHorizontal) {
          let counterTransform = 'translate(-50%, -50%)';
          if (layout.rotation) {
            counterTransform += ` rotate(${-layout.rotation}deg)`;
          }
          if (layout.flipHorizontal) {
            counterTransform += ' scaleX(-1)';
          }
          labelStyle = { transform: counterTransform };
        }
        idLabel = <span className={'fuse-id-label'} style={labelStyle}>{id}</span>;
      }
    }

    if(!npc) {
      return <div
        data-fuse-idx={i}
        onClick={(e) => this.selectFuse(fuse, e)}
        onTouchStart={(e) => this.handleFuseTouchStart(fuse, e)}
        onMouseEnter={(e) => this.hoverFuse(fuse, e)}
        onMouseLeave={(e) => this.hoverFuse(null, e)}
        key={fuseId + '_' + i}
        className={fuseClass} style={fuseStyle}>
        <div className={'inner'}>{inner}</div>
        {idLabel}
        {fuseMark ? <span className={'fuse-mark'}>{fuseMark}</span> : null}
      </div>
    } else {
      return <div
        key={fuseId + '_' + i}
        className={fuseClass} style={fuseStyle}>
        <div className={'inner'}>{inner}</div>
        {fuseMark ? <span className={'fuse-mark'}>{fuseMark}</span> : null}
      </div>
    }
  }

  renderIcon(icon, viewBox, i, isLightBackground) {
    const {layout, fuseId, fuse, entity, arrow} = icon;

    if(!layout?.width) {
      return null
    }

    let iconStyle = this.getBoxCss(layout, viewBox);


    let iconClass = `fuseIcon fuseIcon-${entity}`;
    const iconSelected = _.includes(_.map(this.state.selected, 'id'), fuseId) || _.includes(this.state.highlightedIds, fuseId);
    if (this.state.selected?.length || this.state.highlightedIds?.length) {
      if (iconSelected) {
        if(!this.state.hoverSelection) {
          iconClass += ' highlighted'
        } else {
          iconClass += ' hovered'
        }
        iconStyle.zIndex = '1001'
      }
    }

    if(isLightBackground && layout.orientation !== 'overlay') {
      iconClass += ' iconDark';
    }

    if(layout.orientation) {
      iconClass += ` iconOrientation-${layout.orientation}`;
    }

    return <div
      data-icon-idx={i}
      onClick={(e) => this.selectFuse(fuse, e)}
      onTouchStart={(e) => this.handleFuseTouchStart(fuse, e)}
      onMouseEnter={(e) => this.hoverFuse(fuse, e)}
      onMouseLeave={(e) => this.hoverFuse(null, e)}
      key={entity+i}
      className={iconClass} style={iconStyle}>
        <div className={'iconArrow'}></div>
    </div>
  }

  getBoxCss(layout, viewBox) {
    let { left, top, width, height } = viewBox;
    return {
      width: `${layout.width/(width/100)}%`,
      height: `${layout.height/(height/100)}%`,
      left: `${(layout.left - left)/width*100}%`,
      top: `${(layout.top - top)/height*100}%`,
    };
  }

  updateDimensions() {
    let {fitScreen, fitMargins, fitScreenWidth, fitScreenHeight, fitWidth, fitHeight} = this.props;

    fitMargins = {top: 10, left: 0, maxWidth: Infinity, ... (fitMargins || {})};


    let $containerHeight = (fitScreen || fitScreenHeight || this.state.fullScreen) ? $(window) : $(this.containerRef.current);
    let $containerWidth = (fitScreen || fitScreenWidth || this.state.fullScreen) ? $(window) : $(this.containerRef.current);

    if($containerHeight.length) {
      let h = (!this.state.fullScreen && fitHeight) ? fitHeight : $containerHeight.outerHeight();
      let w = (!this.state.fullScreen && fitWidth) ? fitWidth : $containerWidth.outerWidth();

      if(fitScreen && !fitHeight) {
        // For some reason, window.outerHeight returns null in recently opened tabs that still remain hidden
        // Also, innerHeight will change in mobile when the url bar appears/dissapears on scroll
        h = window.innerHeight;
      }

      let maxHeight = h - (this.state.fullScreen ? 0 : fitMargins.top);
      let maxWidth = Math.min(fitMargins.maxWidth, w - ((this.state.fullScreen ? 0 : fitMargins.left)));

      // console.log(`UPDATE DIMENSIONS: ${maxWidth}x${maxHeight} - MARGIN: ${fitMargins.maxWidth}x${w}`);

      // Subtract chrome (title + buttons rows + search row) from available height
      if(this.containerRef.current) {
        const btnsEl = this.containerRef.current.querySelector('.fusebox-diagram__cell--btns');
        const titleEl = this.containerRef.current.querySelector('.fusebox-diagram__cell--title');
        const searchEl = this.containerRef.current.querySelector('.fusebox-diagram__cell--search');
        const btnsH = btnsEl?.offsetHeight || 0;
        const titleH = titleEl?.offsetHeight || 0;
        const searchH = searchEl?.offsetHeight || 0;
        // When container >= 500px, CSS container query puts btns and title in the same row
        const chromeH = (w >= 500 ? Math.max(btnsH, titleH) : btnsH + titleH) + searchH;
        if(chromeH > 0) {
          maxHeight = Math.max(0, maxHeight - chromeH);
        }
      }
      
      let wideLayouInColumns = false;

      // Auto-rotate in fullscreen to maximize diagram size
      let fullScreenAutoRotation = 0;
      if(this.state.fullScreen && this.preprocessed?.viewBox) {
        let ar = this.preprocessed.viewBox.aspectRatio; // height/width
        // Undo current auto-rotation to get the base aspect ratio
        if(this.state.fullScreenAutoRotation) {
          ar = 1 / ar;
        }
        const fittedArea = (ratio, mW, mH) => mH / mW > ratio ? ratio * mW * mW : mH * mH / ratio;
        const currentArea = fittedArea(ar, maxWidth, maxHeight);
        const rotatedArea = fittedArea(1 / ar, maxWidth, maxHeight);
        if(rotatedArea > currentArea * 1.30) {
          fullScreenAutoRotation = 90;
        }

      
        // Check if we would get a larger diagram by moving to three columns layout
        if(this.state.fullScreen) {
          const MIN_COLUMN_WIDTH = 150;
          const effectiveAR = fullScreenAutoRotation ? 1 / ar : ar; // height/width after rotation
          const isHeightBounded = h / w < effectiveAR;
          if(isHeightBounded) {
            const fittedWidth = h / effectiveAR;
            if(w - fittedWidth >= 2*MIN_COLUMN_WIDTH) {
              wideLayouInColumns = true;
              maxWidth = maxWidth - 2*MIN_COLUMN_WIDTH;
              maxHeight = h;
            }
          }
        }
      }
    
      this.setState({maxHeight, maxWidth, fullScreenAutoRotation, wideLayouInColumns});
    } else {
      console.warn("No container length to update diagram dimensions")
    }
  }

  componentDidMount() {
    this._updateDimensionsImmediate();

    // Sometimes the scrollbar is not yet rendered, producing incorrect width
    setTimeout(() => this._updateDimensionsImmediate(), 1)

    if (typeof ResizeObserver !== 'undefined' && this.containerRef.current) {
      this._containerResizeObserver = new ResizeObserver(() => this.updateDimensions());
      this._containerResizeObserver.observe(this.containerRef.current);
    } else {
      // Resize event is problematic in iOS/Safari when pinch zooming. Last resort.
      window.addEventListener("resize", this.updateDimensions);
    }

    if (this.props.fuseTouchContinuousHover && this.viewportRef.current) {
      this.viewportRef.current.addEventListener('touchmove', this.handleTouchMove, { passive: false });
      this.viewportRef.current.addEventListener('touchend', this.handleTouchEnd);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);

    if (this._resizeRAF) cancelAnimationFrame(this._resizeRAF);
    if (this._containerResizeObserver) {
      this._containerResizeObserver.disconnect();
      this._containerResizeObserver = null;
    }

    if (this.viewportRef.current) {
      this.viewportRef.current.removeEventListener('touchmove', this.handleTouchMove);
      this.viewportRef.current.removeEventListener('touchend', this.handleTouchEnd);
    }
  }

  toggleFullScreen() {
    const fullScreen = !this.state.fullScreen;
    this.setState({ fullScreen }, () => this.updateDimensions())
    if (this.props.onFullScreenToggle) {
      this.props.onFullScreenToggle(fullScreen)
    }

    // This is needed to prevent the page from scrolling when the full screen is toggled
    // Unfortunatelu, overscroll-behavior: contain; does not work properly in iOS/Safari.
    if (fullScreen) {
      const scrollY = window.scrollY;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
    } else {
      const scrollY = -parseInt(document.body.style.top || '0');
      document.documentElement.style.overflow = 'auto';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';

      window.scrollTo(0, scrollY);
    }
  }

  rotateExtraDegrees() {
    const newRotationAngle = (this.state.extraRotation + 90) % 360;
    this.setState({ extraRotation: newRotationAngle });
    if(this.props.onRotate) {
      this.props.onRotate(newRotationAngle);
    }
  }

  render() {
    try {

      const effectiveExtraRotation = (this.state.extraRotation + this.state.fullScreenAutoRotation) % 360;
      if(!this.preprocessed || this.props.development || this.lastFusebox !== this.props.fusebox || this.lastExtraRotation !== effectiveExtraRotation) {
        this.lastFusebox = this.props.fusebox;
        this.lastExtraRotation = effectiveExtraRotation;
        let fuseboxData = this.props.fusebox;
        if(effectiveExtraRotation) {
          fuseboxData = { ...fuseboxData, boxRotation: ((fuseboxData.boxRotation || 0) + effectiveExtraRotation) % 360 };
        }
        console.time('preprocessDiagram');
        this.preprocessed = this.preprocessDiagram(fuseboxData);
        console.timeEnd('preprocessDiagram');
      }

      const { boxName, boxDescription, viewBox, fuses, icons, backgroundColor, hasSvg } = this.preprocessed;

      let maxHeight = this.state.maxHeight;
      let maxWidth = this.state.maxWidth;

      let h,w=null;
      if (maxHeight / maxWidth > viewBox.aspectRatio) {
        h = viewBox.aspectRatio * maxWidth
        w = maxWidth
      } else {
        w = maxHeight / viewBox.aspectRatio
        h = maxHeight
      }
      const boxStyle = { height: `${h}px`, width: `${w}px` };

      const isLightBackground = backgroundColor && contrastRequiresBlack(backgroundColor);
      let backgroundClass = isLightBackground ? 'fusebox-diagram--light' : 'fusebox-diagram--dark';

      const diagramBackground = {};

      if(hasSvg) {
        diagramBackground.backgroundColor = 'transparent';
        backgroundClass += ' fusebox-diagram--has-svg';
      }

      if(backgroundColor) {
        diagramBackground.backgroundColor = diagramBackground.backgroundColor || backgroundColor;
        diagramBackground["--diagramBackground"] = backgroundColor;
      }


      let fitScreenClass = this.props.fitScreen ? 'fusebox-diagram--fitScreen' : 'fusebox-diagram--dontFitScreen';
      let fullScreenClass = this.state.fullScreen ? 'fusebox-diagram--fullScreen' : '';
      let wideChromeClass = this.state.wideLayouInColumns ? 'fusebox-diagram--wideChrome' : '';
      let fitWidthClass = (this.props.fitWidth && !this.state.fullScreen) ? 'fusebox-diagram--fitWidth' : '';
      let showIdsClass = this.props.showFuseIds ? 'fusebox-diagram--show-ids' : '';

      let extraStyleVars = {};
      if(this.props.fitMargins?.top) {
        extraStyleVars['--fusebox-margin-top'] = this.props.fitMargins?.top + 'px';
      }
      if(this.props.fitMargins?.left) {
        extraStyleVars['--fusebox-margin-left'] = this.props.fitMargins?.left + 'px';
      }

      let selectedInfo = null, selectedArrow;

      if (this.state.selected?.length) {
        let selected = _.filter(fuses, f => _.includes(_.map(this.state.selected, 'id'), f.id));
        // In some edge cases, the fuses are changed and an outdated selection remains
        let layout = selected[0]?.layout;
        if(layout) {
          let fuseCenterX = layout.left+layout.width/2;
          let diagramCenter = viewBox.left + viewBox.width/2;
          let fuseToTheLeft = fuseCenterX < diagramCenter;
          let globeSide = (fuseToTheLeft ? ' box-right' : ' box-left')
          selectedInfo = <div className={'selectedfuse ' + globeSide}>
            <div className={'globe'} style={this._touchActive ? {pointerEvents: 'none'} : {}}> {
              // Use fuse.description in key in case fuseId is repeated, happens in some fusebox variations
              _.map(selected, fuse => {
                  let { amp, type, format } = fuse.kind || {};
                  const ampColor = amp ? { backgroundColor: FUSE_COLORS[fuse.kind.format]?.[amp] } : null;

                  const displayType = FUSE_NAMES_LOCALIZED.types[type] || type;
                  const displayFormat = FUSE_NAMES_LOCALIZED?.formats?.[type]?.[format] || '';

                let icons = fuse.icons;
                let iconsImgs = icons?.length ? <div className={'fuse-icons'}>
                  { icons.map(entity => {
                    return <div key={entity} className={`fuseIcon fuseIcon-${entity}`}/>;
                  }) }
                </div> : null;

                return <div className={'fuse-info'} key={fuse.id + (fuse.option || '')}>
                  <div className={'fuse-id-format'}>
                    <span className={'fuse-number'}>{fuse.id}</span>

                    <span className={'ml-1 fuse-format'}>
                      {displayType} {displayFormat}
                      {amp ? <span className={'ml-1 amp'} style={ampColor}>{fuse.kind.amp}A</span> : null}
                    </span>
                  </div>

                  <div className={'fuse-icon-description'}>
                    {iconsImgs}

                    <div className={'fuse-description'}>{fuse.description}</div>
                    {fuse.individualFusePages?.length ? fuse.individualFusePages.map(f => {
                      return f.urlWithAnchor? <div style={{fontSize: '12px'}} className={'pt-05'}>
                        <a className={'text-weight-normal'} href={f.urlWithAnchor}>{f.problemsTitle}...</a>
                      </div> : null;
                    }) : null}
                  </div>
                </div>;
                }
              )
            }
            </div>
          </div>;

          let x1 = w*(fuseCenterX-viewBox.left)/viewBox.width;
          let y1 = h*(layout.top+layout.height/2-viewBox.top)/viewBox.height;
          selectedArrow = <svg width={w} height={h} className={'fusebox-selection-globe-arrow'}>
            <line x1={x1} y1={y1} x2={fuseToTheLeft ? w*0.8 : w*0.2} y2={h/2} stroke={'white'} strokeLinecap="round" strokeWidth={3}/>
            <circle cx={x1} cy={y1} r={7} stroke={'white'} fill={'none'} strokeWidth={1}/>
          </svg>
        }
      }

      return <div ref={this.containerRef} style={extraStyleVars} className={['fusebox-diagram', fitScreenClass, fullScreenClass, wideChromeClass, fitWidthClass, showIdsClass, backgroundClass].join(' ')}>
        <div className={'fusebox-diagram__layout'} onClick={(e) => this.selectFuse(null, e)}>
          <div className={'fusebox-diagram__cell fusebox-diagram__cell--btns'}>
            {
              this.props.hideTitle ? null :
                <div className={'fusebox-btns'}>
                  <span onClick={(e) => this.toggleFullScreen() + e.stopPropagation()} className={'fusebox-btn text-white'} title={'Full screen'}>
                    <span alt={'Full screen'} className={`IconSvg IconSvg--${this.state.fullScreen ? 'ExitFullScreen' : 'FullScreen'}`} />
                  </span>

                  {this.props.showRotateButton || this.state.fullScreen ?
                    <span onClick={(e) => this.rotateExtraDegrees() + e.stopPropagation()} className={'fusebox-btn text-white'} title={'Rotate diagram'}>
                      <span alt={'Rotate'} className={`IconSvg IconSvg--Rotate`} />
                    </span>
                    : null}
                </div>
            }
          </div>

          <div className={'fusebox-diagram__cell fusebox-diagram__cell--title text-center fusebox-title'} onClick={(e) => this.selectFuse(null, e)}>
            {
              this.props.hideTitle ? null :
                <div className={'fusebox-title-name '+(this.props.clipTitle ? 'fusebox-title-name--clip' : '')}>{boxName}</div>
            }

            {
              ((this.props.showInstructions) && !this.state.fullScreen) ?
                <div className={'text-center'}>
                  <span className={'FuseboxDiagram__instructions'}>
                    <span className={'text-center'}>👆&nbsp;&nbsp; {FUSE_NAMES_LOCALIZED.messages['touch-to-see-function']}</span>
                  </span>
                </div> : null
            }          
          </div>

          <div ref={this.diagramCellRef} className={'fusebox-diagram__cell fusebox-diagram__cell--diagram'} onClick={(e) => this.selectFuse(null, e)}>
            <div ref={this.viewportRef} style={boxStyle} className={'fusebox-viewport'} onClick={(e) => this.selectFuse(null, e)}>
              <div className={'fusebox'} style={diagramBackground}>
                {
                  _.map(fuses, (fuse, i) => this.renderFuse(fuse, viewBox, i))
                }

                {
                  _.map(icons, (icon, i) => this.renderIcon(icon, viewBox, i, isLightBackground))
                }

                <div className={'fusebox-selection-overlay '+(this.state.selected?.length ? 'selection-active' : '')}/>
                {selectedArrow}
              </div>
            </div>
            {selectedInfo}
          </div>

          { this.renderFuseSearchBar() }
        </div>
      </div>
    } catch(err) {
      return <div className={'bg-dark text-white p-5'}>
        <div className={'text-center mb-3'}>There was a problem trying to build fusebox diagram, check that the diagram is finished</div>
        <div className={'alert alert-danger'}>{err.toString()}</div>
      </div>
    }
  }

  renderFuseSearchBar() {
    if(!this.props.onFuseSearch || this.state.fullScreen)
      return <div className={'fusebox-diagram__cell fusebox-diagram__cell--search'}/>;

    let showPrevNextButtons = this.state.currentSearch && this.state.highlightedIds?.length > 1;
    let currentIndex = 0, prevFuse = null, nextFuse = null;

    let total = this.state.highlightedIds?.length || 0;
    if (showPrevNextButtons) {
      currentIndex = Math.max(0, this.state.highlightedIds.indexOf(this.state.selected[0]?.id));
      nextFuse = this.props.fusebox.fuses.find(f => f.id === this.state.highlightedIds[(currentIndex + 1) % total]);
      prevFuse = this.props.fusebox.fuses.find(f => f.id === this.state.highlightedIds[(currentIndex - 1 + total) % total]);
    }

    const clearSearch = () => {
      this.search('');
      this.highlightFuses([]);
      this.props.onSearchCleared && this.props.onSearchCleared();
    };

    return <div className={'fusebox-diagram__cell fusebox-diagram__cell--search'}>    

      <div className={'FuseboxDiagram__search-fuses'}>
        <input type='text'
          placeholder={__('views.infoFusebox.searchFusesPlaceholder')}
          className={'WizardTextInput WizardTextInput--search'}
          onClick={this.props.onFuseSearch}
          value={this.state.currentSearch}
        />
      { this.state.currentSearch ? <button className='FuseboxDiagram__search-fuses-clearbtn' onClick={clearSearch}>
        <svg fill="#ffffff" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          <path d="M0-.25h24v24H0z" fill="none" />
        </svg>
      </button> : null}      
      </div>

      {showPrevNextButtons ? <div className={'text-center'} style={{flexShrink: 0}}>
        <span className='FuseboxDiagram__search-fuses-index'>{(currentIndex + 1)} / {total}</span>&nbsp;
        <button className='FuseboxDiagram__search-fuses-btn' onClick={(e) => { this.selectFuse(prevFuse); e.stopPropagation() }}>
          <svg fill="#ffffff" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.41 16.34l-4.58-4.59 4.58-4.59L14 5.75l-6 6 6 6z" />
            <path d="M0-.25h24v24H0z" fill="none" />
          </svg>
        </button>
        <button className='FuseboxDiagram__search-fuses-btn' onClick={(e) => { this.selectFuse(nextFuse); e.stopPropagation() }}>
          <svg fill="#ffffff" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
            <path d="M0-.25h24v24H0z" fill="none" />
          </svg>
        </button>
      </div> : null}
    </div>
  }

  search(value) {
    this.setState({ currentSearch: value });
  }

  static  mergeMultiBlockFuses(box) {
    // Find and merge multiblock fuses
    const blockTypes = ['fuse-block', 'fuse-mpf', 'fuse-mpf2'];
    let blockFusesIds = {};
    let extras = [];
    box.fuses = _.filter(box.fuses, (f, i) => {
      const type = f.kind?.type;

      if (f.layout && (blockTypes.includes(type) || f.kind?.format === 'micro3')) {
        const sameIdBlock = blockFusesIds[type]?.[f.id];
        let collidingBlocks = _.filter(_.values(blockFusesIds[type]), block => areTouching(block.layout, f.layout))

        if (sameIdBlock || collidingBlocks.length) {
          if (sameIdBlock) {
            sameIdBlock.description += '.\n\n' + f.description;
            return false;
          } else {
            let anchorBlock;
            for(const collidingBlock of collidingBlocks) {
              if(anchorBlock) {
                // F was already processed, merge other blocks that appear to be part of the block
                anchorBlock.layout = mergeLayoutBoxes(collidingBlock.layout, anchorBlock.layout);

                // If we are merging a block merely created to draw the block, delete it, the anchor already covers it
                if(collidingBlock.npc) {
                  extras = _.without(extras, collidingBlock)
                } else {
                  collidingBlock.onlyBlockSelection = true;
                }
              } else {
                anchorBlock = collidingBlock;
                if (!anchorBlock.npc) {
                  anchorBlock.onlyBlockSelection = true;
                  let newBlock = {
                    ..._.cloneDeep(anchorBlock),
                    id: 'multi__' + anchorBlock.id,
                    description: 'multiblock',
                    npc: true,
                    onlyBlockSelection: false
                  };
                  blockFusesIds[type][anchorBlock.id] = newBlock;
                  extras.push(newBlock);
                  anchorBlock = newBlock;
                }

                anchorBlock.layout = mergeLayoutBoxes(f.layout, anchorBlock.layout);
                // console.log(`Merged: ${collidingBlock.id} - ${f.id}`)
                f.onlyBlockSelection = true;

                anchorBlock = collidingBlock;
              }
            }
          }
        } else {
          blockFusesIds[type] = blockFusesIds[type] || {};
          blockFusesIds[type][f.id] = f;
        }
      }
      return true;
    });
    return box.fuses.concat(extras);
  }

  static preprocessBoxesSizeAndOrientation(originalBox) {
    const box = _.cloneDeep(originalBox);
    const aspectRatio = box.boxAspectRatio || 1;

    // 1. Convert all coordinates to a 1:1 aspect ratio
    _.each(box.fuses, fuse => {
      if (fuse.layout?.height && fuse.layout?.width) {
        fuse.layout.width /= aspectRatio;
        fuse.layout.left /= aspectRatio;
      }
    });

    // 2. Merge multi-block fuses
    box.fuses = FuseboxDiagram.mergeMultiBlockFuses(box);

    let fusesWithLayout = _.filter(box.fuses, f => f.layout?.width);

    // 3. Apply geometric transformations and compute final rotations
    _.each(fusesWithLayout, fuse => {
      let { left, top, width, height } = fuse.layout;
      let extraRotation = fuse.layout.rotation || 0;

      // Special handling for SVG fuses
      if (fuse.kind?.type === 'svg' || fuse.kind?.format === 'camera-viewport') {
        fuse.npc = true;
        box.hasSvg = true;
      }

      // --- Compute Original Base Rotation (before any diagram rotation) ---
      let defaultFormatSize = fuseImageFormat({ ...fuse, vertical: false });
      let defaultIsVertical = !!defaultFormatSize?.isVertical;
      
      let origBoxIsVertical = width * 1.1 < height;
      let origBoxIsHorizontal = width / 1.1 > height;
      let origVertical = defaultIsVertical ? origBoxIsHorizontal : origBoxIsVertical;
      
      let origFormatSize = fuseImageFormat({ ...fuse, vertical: origVertical });
      let originalBaseRotation = 0;
      if (origVertical && !origFormatSize?.dontRotateVertical) {
        if (!!origFormatSize?.isVertical !== origBoxIsVertical) {
          originalBaseRotation = 90;
        }
      }

      // --- Apply Diagram Rotation to Box Center ---
      let cx = left + width / 2;
      let cy = top + height / 2;
      let newWidth = width;
      let newHeight = height;

      if (box.boxRotation) {
        if (box.boxRotation === 90) {
          [cx, cy] = [100 - cy, cx];
          if (fuse.kind?.type !== 'svg') [newWidth, newHeight] = [height, width];
        } else if (box.boxRotation === 180) {
          [cx, cy] = [100 - cx, 100 - cy];
        } else if (box.boxRotation === 270) {
          [cx, cy] = [cy, 100 - cx];
          if (fuse.kind?.type !== 'svg') [newWidth, newHeight] = [height, width];
        }
      }

      // --- Apply Diagram Flip Horizontal to Box Center ---
      if (box.flipHorizontal) {
        cx = 100 - cx;
      }

      // Update bounding box
      fuse.layout.width = newWidth;
      fuse.layout.height = newHeight;
      fuse.layout.left = cx - newWidth / 2;
      fuse.layout.top = cy - newHeight / 2;

      // --- Compute Final Visual Rotation ---
      if (fuse.kind?.type === 'svg') {
        fuse.layout.rotation = (box.boxRotation || 0) + extraRotation;
        if (box.flipHorizontal) {
          fuse.layout.flipHorizontal = true;
        }
      } else {
        // Determine if the final box is visually vertical
        let boxIsVertical = newWidth * 1.1 < newHeight;
        let boxIsHorizontal = newWidth / 1.1 > newHeight;
        
        // fuse.vertical signifies if the shape is placed in a non-default orientation
        fuse.vertical = defaultIsVertical ? boxIsHorizontal : boxIsVertical;
        let formatSize = fuseImageFormat(fuse);
        
        let baseRotation = 0;
        if (fuse.vertical && !formatSize?.dontRotateVertical) {
          if (!!formatSize?.isVertical !== boxIsVertical) {
            baseRotation = 90;
          }
        }

        let finalRotation = baseRotation;

        // Asymmetrical shapes must preserve their physical orientation relative to the diagram
        if (formatSize?.asymetrical) {
          finalRotation = originalBaseRotation + (box.boxRotation || 0);
        }

        // Apply user's manual extra rotation
        finalRotation += extraRotation;

        // Apply flip horizontal logic for images
        if (box.flipHorizontal) {
          if (finalRotation || formatSize?.asymetrical) {
            let r = finalRotation % 360;
            if (formatSize?.asymetrical && !formatSize?.symetricalYAxis) {
              finalRotation = 180 - r;
            } else {
              finalRotation = -r;
            }
          }
        }

        fuse.layout.rotation = finalRotation;
      }
    });

    return box;
  }

  preprocessDiagram(originalBox) {
    const box = FuseboxDiagram.preprocessBoxesSizeAndOrientation(originalBox);

    let fusesWithLayout = _.filter(box.fuses, f => f.layout?.width);

    // Re-scale fuses according to their type/format real world dimension
    let scaleMultiplier = parseFloat(box.boxScaleMultiplier);
    scaleMultiplier = isNaN(scaleMultiplier) ? 1: scaleMultiplier;

    let scale = FuseboxDiagram.computeAverageFuseScale(fusesWithLayout) * scaleMultiplier;

    _.each(fusesWithLayout, fuse => this.changeSizeToScaleModel(fuse, scale))

    // Remove all margins, find bounding box containing all fuse boxes
    let minY = 100;
    let minX = 100;
    let maxY = 0;
    let maxX = 0;

    _.each(fusesWithLayout, ({ layout: {top, left, height, width, rotation }, kind, description, ignoreAndCrop}) => {
      if(ignoreAndCrop) {
        return;
      }

      let [x,y,x2,y2] = [left, top, left+width, top+height];

      // If rotation is not a multiple of 90, we need the proper bounding box corners
      if(rotation) {
        let cx = left + width/2;
        let cy = top + height/2;
        
        let p1 = rotate(cx, cy, left, top, rotation);
        let p2 = rotate(cx, cy, left+width, top, rotation);
        let p3 = rotate(cx, cy, left, top+height, rotation);
        let p4 = rotate(cx, cy, left+width, top+height, rotation);

        x = Math.min(p1[0], p2[0], p3[0], p4[0]);
        y = Math.min(p1[1], p2[1], p3[1], p4[1]);
        x2 = Math.max(p1[0], p2[0], p3[0], p4[0]);
        y2 = Math.max(p1[1], p2[1], p3[1], p4[1]);
      }

      minY = Math.min(minY, y, y2);
      minX = Math.min(minX, x, x2);
      maxY = Math.max(maxY, y, y2);
      maxX = Math.max(maxX, x, x2);
    });

    box.icons = this.buildIconsMarks(fusesWithLayout, maxX - minX, maxY- minY, scale);

    // Take icons into account when calculating the box size
    _.each(box.icons, ({ layout: {top, left, height, width }}) => {
      let [x,y,x2,y2] = [left, top, left+width, top+height];
      minY = Math.min(minY, y, y2);
      minX = Math.min(minX, x, x2);
      maxY = Math.max(maxY, y, y2);
      maxX = Math.max(maxX, x, x2);
    });

    let margin = Math.max(0.02*(maxX - minX), 0.02*(maxY - minY));
    // Crop everything leaving a % margin horizontally and vertically
    box.viewBox = {
      top: minY - margin,
      left: minX - margin,
      width: maxX - minX+2*margin,
      height: maxY - minY+2*margin,
    };

    box.viewBox.aspectRatio = box.viewBox.height / box.viewBox.width;

    // Find fuse ids with multiple options, and leave a mark so that they can be rendered split in 2 or 3
    let fusesById = _.groupBy(fusesWithLayout, 'id');
    _.each(fusesById, ( fuses, id) => {
      if(fuses.length > 1) {
        _.each(fuses, (f,i) => {
          f.option = i;
          f.totalOptions = fuses.length;
        })
      }
    });

    box.processed = true;
    box.scale = scale;

    // Transform the entire box to 0-100 percentages

    return box;
  }

  getSemanticIcons(semantics) {
    return _.uniq(_.compact((semantics || []).map(sem => getSemanticIcon(sem))));
  }

  buildIconsMarks(fuses, boxWidth, boxHeight, scaleInMM) {
    let fusesWithIcons = _.filter(fuses, f => {
      f.icons = this.getSemanticIcons(f.relatedEntities);
      return !f.npc && f.icons.length > 0;
    })

    // Icon height and width in %
    // Scale according to the real size of the diagram once it is cropped
    // Ensure that even the icon is "physically" at least the height of a micro to ensure in small diagrams with few
    // fuses that the icons are not too small;
    let scale = Math.max(boxWidth, boxHeight) / 100;
    let minScaleInMM = scaleInMM*6;
    const iconDiameter = Math.max(4.4*scale, minScaleInMM);
    const iconRadius = iconDiameter/2;

    const fixRotatedLayout = (layout, format) => {
      let { top, left, width, height, rotation, translateX, translateY} = layout;

      if(rotation === 90) {
        [left, top, width, height] = [left + width / 2, top + height / 2, height, width]

        layout = {
          ...  layout,
          left: left - width / 2 - width*parseFloat(translateY || '0')/100,
          top: top - height / 2 + height*parseFloat(translateX  || '0')/100,
          height,
          width,
          rotation: 0
        };
      }

      // The visible box defines, in relative % of the fuse image, what part is the visible to take into account for icons and collisions
      if(format?.visibleBox) {
        let { height: vH, width: vW, top: vT, left: vL } = format.visibleBox;

        if(rotation === 90) {
          [vT, vL, vW, vH] = [vL, 1 - (vT+vH), vH, vW];
        }

        layout = {
          ...  layout,
          top: layout.top + layout.height * vT,
          left: layout.left + layout.width * vL,
          width: layout.width * vW,
          height: layout.height * vH,
        }
      }

      return layout;
    };

    _.each(fuses, fuse => fuse.iconLayout = fixRotatedLayout(fuse.layout, fuseImageFormat(fuse)));

    const minDistanceToFusesOrIcon = ({centerX, centerY}, self, selfRadius = iconRadius) => {
      let min = Number.MAX_VALUE;

      for(let {layout, iconLayout, kind, id, description, npc} of fuses) {
        if(id === self.id || kind?.type === 'svg')
          continue;

        layout = { ... layout, ...iconLayout };

        // const notUsed = kind?.notUsed === true && kind?.type !== 'fuse';
        const notUsed = kind?.notUsed === true || (kind?.type === 'fuse' && kind?.notUsed !== false && !kind?.amp)

        let d = distanceToBoxRotated(centerX, centerY, layout.left, layout.top, layout.width, layout.height, layout.rotation || 0);

        let otherOrNonInteractive = (!description && kind?.type !== 'fuse') || kind?.type === 'other' || kind?.type === 'connector' || notUsed;
        if (otherOrNonInteractive) {
          if (d < selfRadius * 0.7) {
            min = Math.min(min, 0.1); // Make it a last option
          }
        } else {
          min = Math.min(min, d - selfRadius * 0.9);
        }
      }

      for(const {layout} of allIcons) {
        let iconX = layout.left + layout.width/2;
        let iconY = layout.top + layout.height/2;
        let iconDistance = Math.hypot(centerX - iconX, centerY - iconY) - (selfRadius*1.01+selfRadius*1.01);
        // If icon dis > certain distance, ignore it. We wann prioritize filling box gaps, avoiding icons only for collisions
        min = Math.min(min, (iconDistance > iconRadius*0.4) ? 100 : iconDistance);
      }

      // All things equal, things more than 1 icon radius away can be ignored and resolved by the direction bias (to make all top-left etc)
      return Math.min(min, iconRadius*0.75);
    };

    let allIcons = [];

    let iconsById = {};

    _.each(fusesWithIcons, fuse => {
      let { layout, iconLayout, id, kind, vertical } = fuse;

      // Do not repeat entity for the same fuse position (checked by the id)
      iconsById[id] = iconsById[id] || new Set();
      let entity = fuse.icons[0];
      if(iconsById[id].has(entity)) {
        return;
      }

      const format = fuseImageFormat(fuse);

      // const { top, left, width, height, rotation} = fixRotatedLayout(layout, format);
      const { top, left, width, height} = iconLayout || layout;

      const posTop = {centerX: left+width/2, centerY: top - iconRadius, orientation: 'top'};
      const posBottom = {centerX: left+width/2, centerY: top + height + iconRadius, orientation: 'bottom'};
      const posRight = {centerX: left+width+iconRadius, centerY: top + height/2, orientation: 'right'};
      const posLeft = {centerX: left-iconRadius, centerY: top + height/2, orientation: 'left'};

      const candidatePositions = [posTop, posBottom, posLeft, posRight];

      let aspectRatio = boxHeight / boxWidth;
      // For vertical boxes, try not to add icons on the top or bottom
      // Always prefer icons towards edges
      const isUp = (top+height/2) < 50;
      const isLeft = (left+width/2) < 50;
      let [prefUp, prefDown] = isUp ? [0.05, 0.0] : [0, 0.05];
      let [prefLeft, prefRight] = isLeft ? [0.05, 0.0] : [0, 0.05];
      const aspectRatioPreference = aspectRatio < 1 ? [prefUp+0.1, prefDown+0.1, prefLeft, prefRight] : [prefUp, prefDown, prefLeft+0.1, prefRight+0.1];

      let iconPos = null;1
      if(format?.iconInside) {
        iconPos = {
          centerX: left+width*(0.5+(format.iconOffsetX || 0)),
          centerY: top+height*(0.5+(format.iconOffsetY || 0)),
          ... (format.iconOverlay ? {overlay: true} : {orientation: 'center'}),
        };
        // Remove relay text and show icon only
        fuse.layout.hideText = true;
      } else {
        let posCandidates = candidatePositions.map((pos, i) => [pos, minDistanceToFusesOrIcon(pos, fuse), aspectRatioPreference[i]]);
        let [pos, minDistance] = _.maxBy(posCandidates, p => p[1] + p[2]);

        const hasHorizontalShape = width > (height * 1.4);

        let DEBUG_IS_SELECTED = _.map(this.state.selected, 'id').includes(id);

        if (minDistance > 0) { // If enough space t put the icon
          iconPos = pos;
        } else { // If not enough space, but there is space to move the icon over the fuse and fix it
          // The distance has some overlap margin, so ensure the icon is separated from the nearest collision.
          // The original position is some distance from the fuse, ensure that at least it is slightly overlapped
          // Also, the icon is shrinked to 80%, so get it 20% of diameter closer to the fuse
          let shrinkage = iconRadius * 0.2;
          let marginToMove = overlapDistance => Math.min(-Math.min(Math.min(width, height) * 0.2 + shrinkage, iconRadius), overlapDistance - shrinkage);
          // Adjust candidates
          posTop.centerY += -marginToMove(posCandidates[0][1]);
          posBottom.centerY += marginToMove(posCandidates[1][1]);
          posLeft.centerX += -marginToMove(posCandidates[2][1]);
          posRight.centerX += marginToMove(posCandidates[3][1]);

          posCandidates = candidatePositions.map((pos, i) => [pos, minDistanceToFusesOrIcon(pos, fuse, iconRadius*0.8), aspectRatioPreference[i]]);

          // DEBUG_IS_SELECTED && console.log(`ID ${id}, rad=${iconRadius.toFixed(1)}`, posCandidates.map(p => p[1].toFixed(1)).join(', '));

          ([pos, minDistance] = _.maxBy(posCandidates.filter(c => c[1] > -0.5), p => {
            let overlapWithFuse = Math.max(0.01, overlap(p[0].centerX, p[0].centerY, iconRadius * 0.8, fuse.layout.width, fuse.layout.height, fuse.layout.left, fuse.layout.top));
            DEBUG_IS_SELECTED && console.log(`OVERLAP ${id}`, (100*overlapWithFuse).toFixed(0) + '%', p[1].toFixed(1));
            return p[1] + p[2] - overlapWithFuse * iconDiameter;
          }) || []);


          if (pos) {
            pos.orientation = 'center';
            iconPos = pos;
          } else {
            console.log(`Could not place icon in box ${id}, no space to avoid collisions.`)
            return;
          }
        }
      }

      const sizeCorrection = iconPos.orientation === 'center' ? 0.8 : 1

      iconsById[id].add(entity);
      allIcons.push({
        layout: {
          height: iconDiameter * sizeCorrection,
          width: iconDiameter * sizeCorrection,
          top: iconPos.centerY - iconRadius * sizeCorrection,
          left: iconPos.centerX - iconRadius * sizeCorrection,
          orientation: iconPos.overlay ? 'overlay' : iconPos.orientation
        },
        fuseId: id,
        fuse: fuse,
        entity,
      })
    })

    return allIcons;
  }

  static computeAverageFuseScale(fuses) {
    let scales = [];
    _.each(fuses, (fuse) => {
      let { layout: { height, width }, vertical } = fuse;

      let rule = fuseImageFormat(fuse);

      if (rule && width && rule.width && !rule.scaleFreely) {
        const boxIsVertical = width * 1.1 < height;
        if (vertical && !rule.dontRotateVertical && (!!rule.isVertical !== boxIsVertical)) {
          scales.push(Math.min(height / rule.width, width / rule.height));
        } else {
          scales.push(Math.min(width / rule.width, height / rule.height));
        }
      }
    });
    return scales.length && (_.sum(scales) / scales.length);
  }

  changeSizeToScaleModel(fuse, scaleInMM) {
    // For each fuse, we discard the layout height and width, and only use the location (centerX and centerY)
    // of the diagram, and replace the dimensions with real world "at scale" dimensions.
    let { kind, layout, vertical, onlyBlockSelection } = fuse;

    let rule = fuseImageFormat(fuse);

    if (rule && layout.width) {
      let { width, height, left, top } = layout;
      let centerX = left + width / 2;
      let centerY = top + height / 2;

      let w, h;

      let oX = rule.offsetX || 0;
      let oY = rule.offsetY || 0;

      let pngH = (!onlyBlockSelection && rule.pngH) || 1;
      let pngW = (!onlyBlockSelection && rule.pngW) || 1;

      if(onlyBlockSelection) {
        h = height;
        w = width;
      } else if (rule.scaleFreely) {
        // Use width and height for the aspect ratio, but try to keep the average of the box width and height
        let arW = rule.width || 1;
        let arH = rule.height || 1;
        let targetAR = arW / arH;
        let avg = (width + height) / 2;

        let hRaw = avg * 2 / (targetAR + 1);
        let wRaw = hRaw * targetAR;

        h = hRaw * pngH;
        w = wRaw * pngW;
      } else {
        if (rule.width && scaleInMM) {
          h = rule.height * pngH * scaleInMM;
          w = rule.width * pngW * scaleInMM;
        } else {
          const boxIsVertical = width * 1.1 < height;
          if (vertical && !rule.dontRotateVertical && (!!rule.isVertical !== boxIsVertical)) {
            h = width * pngH;
            w = height * pngW;
          } else {
            w = width * pngW;
            h = height * pngH;
          }
        }
      }

      // When rotated, to make the rotation like the original rectangle, no matter the image of the fuse,
      // we first rotate and afterward the image box is translated according to the image definition
      if (layout.rotation) {
        layout.translateX = `${oX * 100}%`;
        layout.translateY = `${oY * 100}%`;

        oX = 0;
        oY = 0;
      }

      layout.width = w;
      layout.height = h;
      layout.left = centerX - w / 2 + w * oX;
      layout.top = centerY - h / 2 + h * oY;
    }
  }
}

// For production
export default FuseboxDiagram

// // For development
// function FB(props) {
//   return <FuseboxDiagram {... props}/>
// }
// export default FB
